import React, { Component } from 'react';
import PropTypes from 'prop-types';
import locales from './locales';
import config from './environments/index';
import * as UTILS_THEMES from './utils/utilsThemes.js';

const helpMenuItems = [
  'section_1',
  'section_2',
  'section_3',
  'section_4',
  'section_5',
  'section_6',
];

class HelpMenuLayer extends Component {
  constructor(props) {
    super(props);
    this.onDefaultMenuLayerClick = this.onDefaultMenuLayerClick.bind(this);
    this.onDefaultSupportLayerClick = this.onDefaultSupportLayerClick.bind(this);
  }

  getLogo() {
    const { theme } = this.props;
    const getLogoURL = () =>
      UTILS_THEMES.getCurrentThemeURL(theme) +
      'globals/src/images/logos/logo_MDirector_header_inverted_trans.png';

    return (
      <div className="logo__container">
        <img alt="MDirector" src={getLogoURL()} className="logo__image" />
      </div>
    );
  }

  getVideo() {
    // Quick exit if video is not enabled:
    // This is useful for development and test environments.
    if (!config.loadHelpVideo) {
      return;
    }

    const { lang } = this.props;
    const t = locales(lang);
    const autoPlay = config.autoPlayVideo;
    let videoURL = t('globalHeader.submenuItems.help.videoURL');

    if (autoPlay) {
      videoURL += '&autoplay=1';
    }

    return (
      <iframe
        width="560"
        height="315"
        src={videoURL}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    );
  }

  getNavItems() {
    const { getGlobalNav, isVisible } = this.props;

    if (isVisible) {
      return getGlobalNav();
    }

    return '';
  }

  renderMenuItem(item, index) {
    const { lang } = this.props;
    const t = locales(lang);
    const langPrefix = 'globalHeader.submenuItems.help.sections.';
    const title = t(`${langPrefix}${item}.title`);
    const url = t(`${langPrefix}${item}.url`);

    return (
      <div className="help__menu__item" key={index}>
        <a href={url} target="_blank" title={title}>
          {title}
        </a>
      </div>
    );
  }

  onDefaultMenuLayerClick(e) {
    const target = e.target;
    const isNavItem = target.className.includes('help__menu--trigger');

    if (!isNavItem) {
      e.stopPropagation();
    }
  }

  onDefaultSupportLayerClick(e) {
    const { openSupportChat } = this.props;

    openSupportChat();
  }

  getSupportButton() {
    const { lang } = this.props;
    const t = locales(lang);

    return (
      <div className="help__menu__support">
        <button className="help__menu__button" onClick={this.onDefaultSupportLayerClick}>
          <span className="help__menu__support__text">
            <span>{t('globalHeader.submenuItems.support.title')}</span>
          </span>
        </button>
      </div>
    );
  }

  getTermsURL() {
    let { properties } = this.props;

    return properties && properties.isAppSumo
      ? 'globalHeader.Legal.termsURLAppsumo'
      : 'globalHeader.Legal.termsURL';
  }
  getLegalLinks() {
    const { lang } = this.props;
    const t = locales(lang);
    return (
      <div className="help__menu__legal">
        <ol>
          <li>
            <a
              className="help__menu__legal__links"
              href={t('globalHeader.Legal.cookiesPolicyURL')}
              title={t('globalHeader.Legal.cookiesPolicy')}
              target="_blank"
            >
              {t('globalHeader.Legal.cookiesPolicy')}
            </a>
          </li>
          <li>
            <a
              className="help__menu__legal__links"
              href={t('globalHeader.Legal.privacyPolicyURL')}
              title={t('globalHeader.Legal.privacyPolicy')}
              target="_blank"
            >
              {t('globalHeader.Legal.privacyPolicy')}
            </a>
          </li>
          <li>
            <a
              className="help__menu__legal__links"
              href={t(this.getTermsURL())}
              title={t('globalHeader.Legal.terms')}
              target="_blank"
            >
              {t('globalHeader.Legal.terms')}
            </a>
          </li>
        </ol>
      </div>
    );
  }

  render() {
    const { isVisible } = this.props;

    const mainClass = isVisible ? 'help__menu__layer open' : 'help__menu__layer';

    return (
      <div className={mainClass} onClick={this.onDefaultMenuLayerClick}>
        <div className="help__menu__layer__header">
          {this.getLogo()}
          {this.getNavItems()}
        </div>
        <div className="help__menu__layer__body">
          <div className="md__header__error__wrapper">
            <div className="md__header__error" />
          </div>
          <div className="help__menu__content">
            <div className="help__menu__items">
              {helpMenuItems.map((item, index) => this.renderMenuItem(item, index))}
              {this.getSupportButton()}
            </div>
            <div className="help__menu__video">{this.getVideo()}</div>
          </div>
          {this.getLegalLinks()}
        </div>
      </div>
    );
  }
}

HelpMenuLayer.propTypes = {
  openSupportChat: PropTypes.func,
  lang: PropTypes.string,
  theme: PropTypes.string,
  getGlobalNav: PropTypes.func,
  isVisible: PropTypes.bool,
  properties: PropTypes.shape({
    isAppSumo: PropTypes.bool,
  }),
};

export default HelpMenuLayer;
